/**
 * Display label for a contract party role. The stored enum keeps
 * 'contractor' (backend contract shape), but every user-facing surface
 * shows 'Supplier' — the organisation's preferred term. Other roles are
 * capitalised as-is.
 */
export function partyRoleLabel(role: string): string {
  if (role === 'contractor') return 'Supplier';
  return role.charAt(0).toUpperCase() + role.slice(1);
}
